var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pso-accordion sidebar",attrs:{"id":"pdf-maps"}},[_c('h3',{staticClass:"pso-accordion__subtitle"},[_vm._v("PDF Maps")]),_c('Accordions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }